import {
  GET_ROLE_DATA_HEALTH,
  receiveRoleDataHealth,
} from "@/components/data/volunteer/ducks/Actions"
import { apiGetRoleDataHealth } from "@/components/data/volunteer/ducks/AJAX"

export default (store) => (next) => (action) => {
  const { dispatch } = store

  const receiveRoleDataHealthSuccess = (cb) => (response) => {
    dispatch(receiveRoleDataHealth(response.stats))
    if (cb) {
      cb()
    }
  }
  switch (action.type) {
    case GET_ROLE_DATA_HEALTH:
      apiGetRoleDataHealth(receiveRoleDataHealthSuccess(action.success), action.error)
      return next(action)

    default:
      return next(action)
  }
}
